export default __webpack_public_path__ + "static/static_chart_en-2dca7422430030b6dbfa24d95821de3f.png";